import { render, staticRenderFns } from "./BtnModule.vue?vue&type=template&id=232b864d&scoped=true&"
import script from "./BtnModule.vue?vue&type=script&lang=js&"
export * from "./BtnModule.vue?vue&type=script&lang=js&"
import style0 from "./BtnModule.vue?vue&type=style&index=0&id=232b864d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b864d",
  null
  
)

export default component.exports